<header class="app-header">
  <div class="header-container">
    <div class="header-logo">
      <img
        alt="Széchenyi Terv Plusz, Magyarország kormánya, EU logó együttes"
        src="assets/images/szechenyi-terv-fekvo.svg"
      />
    </div>
    <div class="header-content">
      <div class="logo">
        <!-- This link will navigate to the home page -->
        <a routerLink="/">Buj Battery</a>
      </div>
      <nav class="main-nav">
        <ul>
          <!-- Link to the Home route -->
          <li><a routerLink="/" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">Főoldal</a></li>
          <!-- This link will navigate to the /news route, which will display the buj-energy component -->
          <li><a routerLink="/news" routerLinkActive="active-link">Hírek</a></li>
        </ul>
      </nav>
    </div>
  </div>
</header>
